import { render, staticRenderFns } from "./ShareToEdit.vue?vue&type=template&id=372163d6&scoped=true"
import script from "./ShareToEdit.vue?vue&type=script&lang=js"
export * from "./ShareToEdit.vue?vue&type=script&lang=js"
import style0 from "./ShareToEdit.vue?vue&type=style&index=0&id=372163d6&prod&lang=scss&scoped=true"
import style1 from "./ShareToEdit.vue?vue&type=style&index=1&id=372163d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372163d6",
  null
  
)

export default component.exports